<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <header-padrao class="mb-2" icon="fa fa-percent" titulo="CADASTRO DE TRIBUTAÇÃO DO ICMS">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap">
            <span class="mr-2">
              <i class="fa fa-key mr-1 text-info"></i>
              ID: <strong class="text-white">{{registro.ID || 'Novo'}}</strong>
            </span>
            <span v-if="registro.DESCRICAO" class="mx-2">•</span>
            <span v-if="registro.DESCRICAO" class="mr-2">
              {{registro.DESCRICAO.substring(0,30)}}
            </span>
            
            <div class="ml-3 d-flex align-items-center">
              <b-badge :variant="registro.SITUACAO === '1' ? 'success' : 'danger'" pill class="px-3 py-1 shadow-sm mr-2">
                {{registro.SITUACAO === '1' ? 'ATIVO' : 'INATIVO'}}
              </b-badge>
            </div>
          </div>
        </template>

        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" @click.stop.prevent="gravar()">
            <i class="fa fa-save mr-1"></i> GRAVAR
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar()">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </header-padrao>

      <b-row class="px-2">
        <b-col sm="12">
          <!-- Dados Básicos -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-info"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Informações Básicas</h6>
                  <small class="text-muted">Identificação da regra de tributação</small>
                </div>
              </div>
            </template>

            <b-row class="mb-3">
               <b-col sm="2">
                <label class="modal-label-premium">ID</label>
                <b-form-input type="text" disabled v-model="registro.ID" class="rounded-pill shadow-xs bg-light"></b-form-input>
              </b-col>
              <b-col sm="2">
                <label class="modal-label-premium">Situação</label>
                <b-form-select v-model="registro.SITUACAO" :options="[{value: '1', text: 'Ativo'}, {value: '0', text: 'Inativo'}]" class="rounded-pill shadow-xs"></b-form-select>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="8">
                <label class="modal-label-premium">Descrição *</label>
                <b-form-input type="text" ref="edDescricao" v-model="registro.DESCRICAO" :state="!!registro.DESCRICAO" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Destino da Operação</label>
                <b-form-select v-model="registro.OP_DESTINO_OPERACAO" :options="opcoesDestinoOperacao" class="rounded-pill shadow-xs"></b-form-select>
              </b-col>
            </b-row>
          </b-card>
          
          <!-- TRIBUTAÇÃO -->
          <b-card no-body class="border-0 shadow-sm mb-4">
            <b-tabs card active-nav-item-class="font-weight-bold text-primary" nav-wrapper-class="border-bottom">
              <b-tab title="TRIBUTAÇÃO" active>
                <div class="p-4">
                    <h6 class="mb-3 font-weight-bold text-muted border-bottom pb-2">ICMS</h6>
                    <b-row>
                        <!-- Coluna 1: ICMS -->
                        <b-col md="6" class="border-right pr-4">
                            <!-- Situação Tributária: sempre visível -->
                            <b-row class="mb-2">
                                <b-col cols="12">
                                    <label class="small font-weight-bold text-muted">ST - Situação Tributária</label>
                                    <b-form-select size="sm" v-model="registro.OP_ICMS_SITUACAO_TRIBUTARIA" :options="opcoesSituacaoTributaria" class="shadow-xs rounded-pill"></b-form-select>
                                </b-col>
                            </b-row>
                            <!-- Origem: sempre habilitado -->
                            <b-row class="mb-2">
                                <b-col cols="12">
                                    <label class="small font-weight-bold text-muted">* Origem</label>
                                    <b-form-select size="sm" v-model="registro.OP_ICMS_ORIGEM" :options="opcoesOrigem" class="shadow-xs rounded-pill"></b-form-select>
                                </b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col cols="12">
                                    <label class="small font-weight-bold text-muted">Codigo Beneficio Fiscal (cBenef)</label>
                                    <b-form-input size="sm" v-model.trim="registro.CBENEF" maxlength="10" class="shadow-xs rounded-pill text-uppercase"></b-form-input>
                                </b-col>
                            </b-row>
                            <h6 class="mb-2 mt-3 font-weight-bold text-muted border-bottom pb-2">Desoneracao ICMS</h6>
                            <b-row class="mb-2">
                                <b-col cols="12">
                                    <label class="small font-weight-bold text-muted">Motivo Desoneracao</label>
                                    <b-form-select size="sm" v-model="registro.OP_MOTIVO_DESONERACAO" :options="motivosDesoneracao" class="shadow-xs rounded-pill"></b-form-select>
                                </b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col cols="8"><label class="small font-weight-bold text-muted">Aliquota Desonerada %</label></b-col>
                                <b-col cols="4"><money v-model="registro.VL_ICMS_ALIQUOTA_DESONERA" v-bind="moneyConfig" class="form-control form-control-sm text-right shadow-xs rounded-pill"></money></b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col cols="12">
                                    <label class="small font-weight-bold text-muted">Deduz do Produto</label>
                                    <b-form-select size="sm" v-model="registro.OP_IND_DEDUZ_DESONERA" :options="deduzDesoneracao" class="shadow-xs rounded-pill"></b-form-select>
                                </b-col>
                            </b-row>

                            <!-- GrupoICMSNormal -->
                            <div v-show="camposAtivos.mostrarGrupoICMSNormal">
                                <b-row class="mb-2">
                                    <b-col cols="12">
                                        <label class="small font-weight-bold" :class="camposAtivos.OP_ICMS_MODAL_DETERM_BC ? 'text-dark' : 'text-muted'">Modalidade de determinação da BC ICMS</label>
                                        <b-form-select size="sm" v-model="registro.OP_ICMS_MODAL_DETERM_BC" :options="opcoesModalidadeBC" :disabled="!camposAtivos.OP_ICMS_MODAL_DETERM_BC" class="shadow-xs rounded-pill" :class="{'campo-desabilitado': !camposAtivos.OP_ICMS_MODAL_DETERM_BC}"></b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="8"><label class="small font-weight-bold" :class="camposAtivos.VL_ICMS_PERCENT_REDUC_BC ? 'text-dark' : 'text-muted'">% de Redução da BC ICMS</label></b-col>
                                    <b-col cols="4"><money v-model="registro.VL_ICMS_PERCENT_REDUC_BC" v-bind="moneyConfig" :disabled="!camposAtivos.VL_ICMS_PERCENT_REDUC_BC" class="form-control form-control-sm text-right shadow-xs rounded-pill" :class="{'campo-desabilitado': !camposAtivos.VL_ICMS_PERCENT_REDUC_BC}"></money></b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="8"><label class="small font-weight-bold" :class="camposAtivos.VL_ICMS_ALIQUOTA ? 'text-dark' : 'text-muted'">Alíquota do ICMS</label></b-col>
                                    <b-col cols="4"><money v-model="registro.VL_ICMS_ALIQUOTA" v-bind="moneyConfig" :disabled="!camposAtivos.VL_ICMS_ALIQUOTA" class="form-control form-control-sm text-right shadow-xs rounded-pill" :class="{'campo-desabilitado': !camposAtivos.VL_ICMS_ALIQUOTA}"></money></b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="8"><label class="small font-weight-bold" :class="camposAtivos.VL_ICMS_PERC_BC_OPER_PROPRIA ? 'text-dark' : 'text-muted'">* % BC da operação própria</label></b-col>
                                    <b-col cols="4"><money v-model="registro.VL_ICMS_PERC_BC_OPER_PROPRIA" v-bind="moneyConfig" :disabled="!camposAtivos.VL_ICMS_PERC_BC_OPER_PROPRIA" class="form-control form-control-sm text-right shadow-xs rounded-pill" :class="{'campo-desabilitado': !camposAtivos.VL_ICMS_PERC_BC_OPER_PROPRIA}"></money></b-col>
                                </b-row>
                                <!-- Grupo ICMS Simples: sempre desabilitado nesta tela normal -->
                                <b-row class="mb-2">
                                    <b-col cols="8"><label class="small font-weight-bold text-muted">* Alíquota aplicável de cálculo do crédito</label></b-col>
                                    <b-col cols="4"><money v-model="registro.VL_ALIQ_APLICAVEL_CALC_CREDITO" v-bind="moneyConfig" disabled class="form-control form-control-sm text-right shadow-xs campo-desabilitado rounded-pill"></money></b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="8"><label class="small font-weight-bold text-muted">Crédito do ICMS aproveitado</label></b-col>
                                    <b-col cols="4"><money v-model="registro.VL_CREDITO_ICMS_APROVEITADO" v-bind="moneyConfig" disabled class="form-control form-control-sm text-right shadow-xs campo-desabilitado rounded-pill"></money></b-col>
                                </b-row>
                            </div>
                            <!-- Mensagem quando nenhum grupo ativo -->
                            <div v-show="!camposAtivos.mostrarGrupoICMSNormal && registro.OP_ICMS_SITUACAO_TRIBUTARIA" class="mt-3">
                                <b-alert show variant="light" class="text-muted small border">Nenhum campo ICMS aplicável para a situação tributária selecionada.</b-alert>
                            </div>
                        </b-col>

                        <!-- Coluna 2: ICMS ST -->
                        <b-col md="6" class="pl-4">
                            <h6 class="mb-3 font-weight-bold text-muted border-bottom pb-2">ICMS ST</h6>
                            <!-- GrupoICMSST -->
                            <div v-show="camposAtivos.mostrarGrupoICMSST">
                                <b-row class="mb-2">
                                    <b-col cols="12">
                                        <label class="small font-weight-bold" :class="camposAtivos.OP_ICMS_MODAL_DETERM_BC_ST ? 'text-dark' : 'text-muted'">Modalidade de determ. da BC ICMS ST</label>
                                        <b-form-select size="sm" v-model="registro.OP_ICMS_MODAL_DETERM_BC_ST" :options="opcoesModalidadeBCST" :disabled="!camposAtivos.OP_ICMS_MODAL_DETERM_BC_ST" class="shadow-xs rounded-pill" :class="{'campo-desabilitado': !camposAtivos.OP_ICMS_MODAL_DETERM_BC_ST}"></b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="8"><label class="small font-weight-bold" :class="camposAtivos.VL_ICMS_PERCENT_REDUC_BC_ST ? 'text-dark' : 'text-muted'">% de Redução da BC ICMS ST</label></b-col>
                                    <b-col cols="4"><money v-model="registro.VL_ICMS_PERCENT_REDUC_BC_ST" v-bind="moneyConfig" :disabled="!camposAtivos.VL_ICMS_PERCENT_REDUC_BC_ST" class="form-control form-control-sm text-right shadow-xs rounded-pill" :class="{'campo-desabilitado': !camposAtivos.VL_ICMS_PERCENT_REDUC_BC_ST}"></money></b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="8"><label class="small font-weight-bold" :class="camposAtivos.VL_ICMS_MARGEM_VL_ADIC_ST ? 'text-dark' : 'text-muted'">% margem de valor adicionado ICMS ST</label></b-col>
                                    <b-col cols="4"><money v-model="registro.VL_ICMS_MARGEM_VL_ADIC_ST" v-bind="moneyConfig" :disabled="!camposAtivos.VL_ICMS_MARGEM_VL_ADIC_ST" class="form-control form-control-sm text-right shadow-xs rounded-pill" :class="{'campo-desabilitado': !camposAtivos.VL_ICMS_MARGEM_VL_ADIC_ST}"></money></b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="8"><label class="small font-weight-bold" :class="camposAtivos.VL_ICMS_ALIQUOTA_ST ? 'text-dark' : 'text-muted'">Alíquota do ICMS ST</label></b-col>
                                    <b-col cols="4"><money v-model="registro.VL_ICMS_ALIQUOTA_ST" v-bind="moneyConfig" :disabled="!camposAtivos.VL_ICMS_ALIQUOTA_ST" class="form-control form-control-sm text-right shadow-xs rounded-pill" :class="{'campo-desabilitado': !camposAtivos.VL_ICMS_ALIQUOTA_ST}"></money></b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="8"><label class="small font-weight-bold" :class="camposAtivos.ID_UF_ICMS_ST ? 'text-dark' : 'text-muted'">UF do ICMS ST devido na Operação</label></b-col>
                                    <b-col cols="4"><b-form-input size="sm" v-model="registro.ID_UF_ICMS_ST" :disabled="!camposAtivos.ID_UF_ICMS_ST" class="shadow-xs rounded-pill" :class="{'campo-desabilitado': !camposAtivos.ID_UF_ICMS_ST}"></b-form-input></b-col>
                                </b-row>
                                <!-- Grupo ICMS Simples ST: sempre desabilitado nesta tela normal -->
                                <b-row class="mb-2">
                                    <b-col cols="8"><label class="small font-weight-bold text-muted">* BC ICMS ST retido anteriormente</label></b-col>
                                    <b-col cols="4"><money v-model="registro.VL_ICMS_BC_ST_RETIDO_ANT" v-bind="moneyConfig" disabled class="form-control form-control-sm text-right shadow-xs campo-desabilitado rounded-pill"></money></b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="8"><label class="small font-weight-bold text-muted">* ICMS ST retido anteriormente</label></b-col>
                                    <b-col cols="4"><money v-model="registro.VL_ICMS_ST_RETIDO_ANT" v-bind="moneyConfig" disabled class="form-control form-control-sm text-right shadow-xs campo-desabilitado rounded-pill"></money></b-col>
                                </b-row>
                            </div>
                            <div v-show="!camposAtivos.mostrarGrupoICMSST && registro.OP_ICMS_SITUACAO_TRIBUTARIA" class="mt-3">
                                <b-alert show variant="light" class="text-muted small border">Substituição Tributária não aplicável para a situação selecionada.</b-alert>
                            </div>
                        </b-col>
                    </b-row>
                </div>
              </b-tab>
            </b-tabs>
          </b-card>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import { Money } from 'v-money'

export default {
  components: {
    HeaderPadrao,
    Money
  },
  data() {
    return {
      registro: {
        ID: null,
        DESCRICAO: '',
        SITUACAO: 'A',
        OP_DESTINO_OPERACAO: null,
        OP_ICMS_SITUACAO_TRIBUTARIA: null,
        OP_ICMS_ORIGEM: null,
        CBENEF: null,
        OP_MOTIVO_DESONERACAO: null,
        VL_ICMS_ALIQUOTA_DESONERA: 0,
        OP_IND_DEDUZ_DESONERA: null,
        OP_ICMS_MODAL_DETERM_BC: null,
        VL_ICMS_PERCENT_REDUC_BC: 0,
        VL_ICMS_ALIQUOTA: 0,
        VL_ICMS_PERC_BC_OPER_PROPRIA: 0,
        VL_ALIQ_APLICAVEL_CALC_CREDITO: 0,
        VL_CREDITO_ICMS_APROVEITADO: 0,
        OP_ICMS_MODAL_DETERM_BC_ST: null,
        VL_ICMS_PERCENT_REDUC_BC_ST: 0,
        VL_ICMS_MARGEM_VL_ADIC_ST: 0,
        VL_ICMS_ALIQUOTA_ST: 0,
        ID_UF_ICMS_ST: null,
        VL_ICMS_BC_ST_RETIDO_ANT: 0,
        VL_ICMS_ST_RETIDO_ANT: 0
        // ... other fields from schema
      },
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      opcoesDestinoOperacao: [
        { value: '1', text: '1 - Operação Interna' },
        { value: '2', text: '2 - Operação Interestadual' },
        { value: '3', text: '3 - Operação com o Exterior' }
      ],
      opcoesSituacaoTributaria: [
        { value: null, text: '-- Selecione --' },
        { value: '00', text: '00 - Tributada Integralmente' },
        { value: '10', text: '10 - Tributada com cobrança do ICMS por Substituição Tributária' },
        { value: '20', text: '20 - Com redução na base de cálculo' },
        { value: '30', text: '30 - Isenta ou não tributada com cobrança do ICMS por subst. tributária' },
        { value: '40', text: '40 - Isenta' },
        { value: '41', text: '41 - Não tributada' },
        { value: '49', text: '49 - Outras (não contribuinte)' },
        { value: '50', text: '50 - Suspensão' },
        { value: '51', text: '51 - Diferimento' },
        { value: '60', text: '60 - Cobrado anteriormente por substituição tributária' },
        { value: '70', text: '70 - Com redução da base de cálculo e cobrança do ICMS por subst. tributária' },
        { value: '90', text: '90 - Outras' }
      ],
      opcoesOrigem: [
        { value: '0', text: '0 - Nacional' },
        { value: '1', text: '1 - Estrangeira - Importação Direta' },
        { value: '2', text: '2 - Estrangeira - Adquirida no Mercado Interno' }
      ],
      opcoesModalidadeBC: [
        { value: '0', text: '0 - Margem Valor Agregado' },
        { value: '1', text: '1 - Pauta (valor)' },
        { value: '2', text: '2 - Preço Tabelado Máx. (valor)' },
        { value: '3', text: '3 - Valor da Operação' }
      ],
      opcoesModalidadeBCST: [
        { value: '0', text: '0 - Preço Tabelado ou Máximo Sugerido' },
        { value: '1', text: '1 - Lista Negativa (Valor)' },
        { value: '2', text: '2 - Lista Positiva (valor)' },
        { value: '3', text: '3 - Lista Neutra (valor)' },
        { value: '4', text: '4 - Margem Valor Agregado (%)' },
        { value: '5', text: '5 - Pauta (valor)' }
      ],
      motivosDesoneracao: [
        { value: null, text: '' },
        { value: '1', text: '1 - Taxi' },
        { value: '2', text: '2 - Deficiente Fisico' },
        { value: '3', text: '3 - Produtor Agropecuario' },
        { value: '4', text: '4 - Frotista/Locadora' },
        { value: '5', text: '5 - Diplomatico/Consular' },
        { value: '6', text: '6 - Amazonia Livre Comercio' },
        { value: '7', text: '7 - SUFRAMA' },
        { value: '8', text: '8 - Venda Orgaos Publicos' },
        { value: '9', text: '9 - Outros' },
        { value: '10', text: '10 - Deficiente Condutor' },
        { value: '11', text: '11 - Deficiente Nao Condutor' },
        { value: '12', text: '12 - Orgao Fomento' },
        { value: '16', text: '16 - Olimpiada Rio 2016' },
        { value: '90', text: '90 - Solicitado Fisco' }
      ],
      deduzDesoneracao: [
        { value: null, text: '' },
        { value: '0', text: 'Nao' },
        { value: '1', text: 'Sim' }
      ]
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },

    camposAtivos() {
      const st = this.registro.OP_ICMS_SITUACAO_TRIBUTARIA
      const campos = {
        // OP_ICMS_ORIGEM é sempre habilitado
        mostrarGrupoICMSNormal: false,
        mostrarGrupoICMSST: false,
        OP_ICMS_MODAL_DETERM_BC: false,
        VL_ICMS_PERCENT_REDUC_BC: false,
        VL_ICMS_ALIQUOTA: false,
        VL_ICMS_PERC_BC_OPER_PROPRIA: false,
        // Grupo ICMS ST
        OP_ICMS_MODAL_DETERM_BC_ST: false,
        VL_ICMS_PERCENT_REDUC_BC_ST: false,
        VL_ICMS_MARGEM_VL_ADIC_ST: false,
        VL_ICMS_ALIQUOTA_ST: false,
        ID_UF_ICMS_ST: false,
        // Grupo ICMS Simples (nunca habilitados na tela normal)
        VL_ALIQ_APLICAVEL_CALC_CREDITO: false,
        VL_CREDITO_ICMS_APROVEITADO: false,
        // Grupo ICMS Simples ST (nunca habilitados na tela normal)
        VL_ICMS_BC_ST_RETIDO_ANT: false,
        VL_ICMS_ST_RETIDO_ANT: false
      }

      switch (st) {
        case '00': // Tributada Integralmente
          campos.mostrarGrupoICMSNormal = true
          campos.OP_ICMS_MODAL_DETERM_BC = true
          campos.VL_ICMS_ALIQUOTA = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          break

        case '10': // Tributada c/ cobrança do ICMS por ST
          campos.mostrarGrupoICMSNormal = true
          campos.mostrarGrupoICMSST = true
          campos.OP_ICMS_MODAL_DETERM_BC = true
          campos.VL_ICMS_ALIQUOTA = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          campos.OP_ICMS_MODAL_DETERM_BC_ST = true
          campos.VL_ICMS_PERCENT_REDUC_BC_ST = true
          campos.VL_ICMS_MARGEM_VL_ADIC_ST = true
          campos.VL_ICMS_ALIQUOTA_ST = true
          break

        case '20': // Com redução na BC
          campos.mostrarGrupoICMSNormal = true
          campos.OP_ICMS_MODAL_DETERM_BC = true
          campos.VL_ICMS_PERCENT_REDUC_BC = true
          campos.VL_ICMS_ALIQUOTA = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          break

        case '30': // Isenta/não-tributada c/ cobrança ICMS por ST
          campos.mostrarGrupoICMSST = true
          campos.OP_ICMS_MODAL_DETERM_BC_ST = true
          campos.VL_ICMS_PERCENT_REDUC_BC_ST = true
          campos.VL_ICMS_MARGEM_VL_ADIC_ST = true
          campos.VL_ICMS_ALIQUOTA_ST = true
          break

        case '40': // Isenta
          campos.mostrarGrupoICMSNormal = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          break

        case '41': // Não tributada
          campos.mostrarGrupoICMSNormal = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          break

        case '49': // Outras (não contribuinte)
          campos.mostrarGrupoICMSNormal = true
          break

        case '50': // Suspensão
          campos.mostrarGrupoICMSNormal = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          break

        case '51': // Diferimento
          campos.mostrarGrupoICMSNormal = true
          campos.OP_ICMS_MODAL_DETERM_BC = true
          campos.VL_ICMS_PERCENT_REDUC_BC = true
          campos.VL_ICMS_ALIQUOTA = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          break

        case '60': // Cobrado anteriormente por ST
          // nenhum campo habilitado além de Origem
          break

        case '70': // Com redução da BC e cobrança ICMS por ST
          campos.mostrarGrupoICMSNormal = true
          campos.mostrarGrupoICMSST = true
          campos.OP_ICMS_MODAL_DETERM_BC = true
          campos.VL_ICMS_PERCENT_REDUC_BC = true
          campos.VL_ICMS_ALIQUOTA = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          campos.OP_ICMS_MODAL_DETERM_BC_ST = true
          campos.VL_ICMS_PERCENT_REDUC_BC_ST = true
          campos.VL_ICMS_MARGEM_VL_ADIC_ST = true
          campos.VL_ICMS_ALIQUOTA_ST = true
          break

        case '90': // Outras
          campos.mostrarGrupoICMSNormal = true
          campos.mostrarGrupoICMSST = true
          campos.OP_ICMS_MODAL_DETERM_BC = true
          campos.VL_ICMS_PERCENT_REDUC_BC = true
          campos.VL_ICMS_ALIQUOTA = true
          campos.VL_ICMS_PERC_BC_OPER_PROPRIA = true
          campos.OP_ICMS_MODAL_DETERM_BC_ST = true
          campos.VL_ICMS_PERCENT_REDUC_BC_ST = true
          campos.VL_ICMS_MARGEM_VL_ADIC_ST = true
          campos.VL_ICMS_ALIQUOTA_ST = true
          break
      }

      return campos
    }
  },

  watch: {
    'registro.OP_ICMS_SITUACAO_TRIBUTARIA'() {
      const c = this.camposAtivos
      // Limpar campos desabilitados conforme regra Delphi
      if (!c.OP_ICMS_MODAL_DETERM_BC)     this.registro.OP_ICMS_MODAL_DETERM_BC = null
      if (!c.VL_ICMS_ALIQUOTA)            this.registro.VL_ICMS_ALIQUOTA = 0
      if (!c.VL_ICMS_PERCENT_REDUC_BC)    this.registro.VL_ICMS_PERCENT_REDUC_BC = 0
      if (!c.VL_ICMS_PERC_BC_OPER_PROPRIA) this.registro.VL_ICMS_PERC_BC_OPER_PROPRIA = 0
      // ST
      if (!c.OP_ICMS_MODAL_DETERM_BC_ST)  this.registro.OP_ICMS_MODAL_DETERM_BC_ST = null
      if (!c.VL_ICMS_ALIQUOTA_ST)         this.registro.VL_ICMS_ALIQUOTA_ST = 0
      if (!c.VL_ICMS_PERCENT_REDUC_BC_ST) this.registro.VL_ICMS_PERCENT_REDUC_BC_ST = 0
      if (!c.VL_ICMS_MARGEM_VL_ADIC_ST)   this.registro.VL_ICMS_MARGEM_VL_ADIC_ST = 0
      if (!c.ID_UF_ICMS_ST)               this.registro.ID_UF_ICMS_ST = null
      // Simples (sempre desabilitados aqui)
      this.registro.VL_ALIQ_APLICAVEL_CALC_CREDITO = 0
      this.registro.VL_CREDITO_ICMS_APROVEITADO = 0
      this.registro.VL_ICMS_BC_ST_RETIDO_ANT = 0
      this.registro.VL_ICMS_ST_RETIDO_ANT = 0
    }
  },
  methods: {
    voltar() {
      this.$router.push('/cadastros/tributacao-icms')
    },
    
    async carregar(id) {
       this.$store.commit('controle/setAguardando', true)
       try {
           const response = await this.$http.get(`/api/protected/tributacaoIcms/getById/${id}`)
           
           if (Array.isArray(response.data) && response.data.length > 0) {
              const item = response.data[0]
              this.registro = { ...this.registro, ...item }
           } else {
               this.$bvToast.toast('Registro não encontrado', { variant: 'warning' })
               this.voltar()
           }

       } catch (err) {
           console.error('Erro ao carregar', err)
           this.$bvToast.toast('Erro ao carregar dados', { variant: 'danger' })
       } finally {
            this.$store.commit('controle/setAguardando', false)
       }
    },

    async gravar() {
        if (!this.registro.DESCRICAO) {
            this.$bvToast.toast('Informe a Descrição', { variant: 'warning' })
            return
        }

        try {
            const body = {
                registro: this.registro,
                login: window.localStorage.getItem('login') || 'sistema'
            }
            
            const isNovo = !this.registro.ID
            let url = '/api/protected/tributacaoIcms/post'
            if (!isNovo) {
                url = '/api/protected/tributacaoIcms/edit'
            }

            const res = await this.$http.post(url, body)

            // Captura o ID do registro salvo para selecionar na listagem
            let idSalvo = null
            
            if (isNovo) {
              // Para novos registros, tenta múltiplas possibilidades
              idSalvo = res.data?.ID || 
                       res.data?.id || 
                       res.data?.insertId || 
                       res.data?.registro?.ID ||
                       res.data?.registro?.id ||
                       null
            } else {
              idSalvo = this.registro.ID
            }
            
            if (idSalvo) {
              this.$store.commit('tributacaoIcms/SET_REGISTRO_SELECIONADO_ID', idSalvo)
            }
            this.$store.commit('tributacaoIcms/SET_RECARREGAR_LISTA', true)

            this.$bvToast.toast('Registro salvo com sucesso', { variant: 'success' })
            this.voltar()

        } catch (err) {
             console.error('Erro ao gravar', err)
             this.$bvToast.toast('Erro ao salvar registro', { variant: 'danger' })
        }
    },
    
    postOrEdit() {
        this.gravar()
    }
  },
  
  created() {
      const id = this.$route.params.id
      if (id) {
          this.carregar(id)
      }
  },
  
  mounted() {
      this.$nextTick(() => {
          if (this.$refs.edDescricao) this.$refs.edDescricao.$el.focus()
      })
  }

}
</script>

<style scoped>
.campo-desabilitado {
  background-color: #e9ecef !important;
  opacity: 0.7;
  cursor: not-allowed;
  pointer-events: none;
}

.modal-label-premium {
    font-size: 0.8rem;
    font-weight: 700;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/tributacao-icms/TributacaoIcmsCadastro.vue